module.exports = __webpack_public_path__ + "assets/devices/Smart-Out-Curtain-c2a0b31a895aaed6af366b8a5ec4fe89.svg";